import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircle, XCircle, Phone, Mail } from 'lucide-react';
export const RepairServices = () => {
  return <div className="min-h-screen bg-slate-50" style={{
    width: '100%'
  }} data-id="element-650">
      <Header data-id="element-651" />
      <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-700 text-white" data-id="element-652">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-653">
          <h1 className="text-5xl font-bold mb-6" data-id="element-654">Repair Service Details</h1>
          <p className="text-xl text-teal-50 max-w-3xl" data-id="element-655">
            Everything you need to know about our professional repair services
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-656">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-657">
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" data-id="element-658">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-659">
              Service Activation & Start Date
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-660">
              Your repair service starts once payment is processed. A
              confirmation email follows shortly. The service runs for the
              selected term (e.g., 12 months) from the purchase date and can be
              renewed on request.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" data-id="element-661">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-662">
              How to Request a Repair
            </h2>
            <div className="space-y-4 mb-6" data-id="element-663">
              <div className="flex items-center space-x-3" data-id="element-664">
                <Phone className="w-6 h-6 text-teal-600" data-id="element-665" />
                <a href="tel:08000554969" className="text-lg text-teal-600 hover:underline" data-id="element-666">
                  0800 055 4969
                </a>
              </div>
              <div className="flex items-center space-x-3" data-id="element-667">
                <Mail className="w-6 h-6 text-teal-600" data-id="element-668" />
                <a href="mailto:Benjobalolong082@gmail.com" className="text-lg text-teal-600 hover:underline break-all" data-id="element-669">
                  Benjobalolong082@gmail.com
                </a>
              </div>
            </div>
            <p className="text-slate-600" data-id="element-670">
              We usually arrange an engineer within 24–48 hours (Monday–Friday).
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" data-id="element-671">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-672">
              What's Included
            </h2>
            <ul className="space-y-4" data-id="element-673">
              <li className="flex items-start space-x-3" data-id="element-674">
                <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-675" />
                <span className="text-slate-600" data-id="element-676">
                  Engineer callouts and diagnostics for registered appliances
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-677">
                <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-678" />
                <span className="text-slate-600" data-id="element-679">
                  Labour included; standard replacement parts fitted when
                  available
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-680">
                <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-681" />
                <span className="text-slate-600" data-id="element-682">
                  Bookings typically within 24–48 hours
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-683">
                <CheckCircle className="w-6 h-6 text-teal-600 flex-shrink-0 mt-1" data-id="element-684" />
                <span className="text-slate-600" data-id="element-685">
                  Repairs for mechanical and electrical faults that arise during
                  the service term
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" data-id="element-686">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-687">
              What's Not Included
            </h2>
            <ul className="space-y-4" data-id="element-688">
              <li className="flex items-start space-x-3" data-id="element-689">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-690" />
                <span className="text-slate-600" data-id="element-691">
                  Cosmetic issues or routine wear and tear
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-692">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-693" />
                <span className="text-slate-600" data-id="element-694">
                  Faults present before the service start date
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-695">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-696" />
                <span className="text-slate-600" data-id="element-697">
                  Damage from misuse, neglect or unauthorised work
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-698">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-699" />
                <span className="text-slate-600" data-id="element-700">
                  Appliances over 10 years old at service start
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-701">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-702" />
                <span className="text-slate-600" data-id="element-703">
                  Damage from external events (fire, flood, power surge, etc.)
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12 mb-8" data-id="element-704">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-705">
              Service Area & Response Times
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-706">
              Mainland UK postcodes. Remote areas may take longer. We aim for
              24–48 hours to schedule (excluding weekends and bank holidays).
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-8 md:p-12" data-id="element-707">
            <h2 className="text-3xl font-bold text-slate-800 mb-6" data-id="element-708">
              Fair Use & Prohibited Activity
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-4" data-id="element-709">
              To keep service fair for all customers, we cannot support:
            </p>
            <ul className="space-y-3 mb-6" data-id="element-710">
              <li className="flex items-start space-x-3" data-id="element-711">
                <span className="text-teal-600 mt-1" data-id="element-712">•</span>
                <span className="text-slate-600" data-id="element-713">
                  Misuse, neglect, or non-standard modifications
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-714">
                <span className="text-teal-600 mt-1" data-id="element-715">•</span>
                <span className="text-slate-600" data-id="element-716">
                  Appliances not used per manufacturer guidelines
                </span>
              </li>
              <li className="flex items-start space-x-3" data-id="element-717">
                <span className="text-teal-600 mt-1" data-id="element-718">•</span>
                <span className="text-slate-600" data-id="element-719">
                  Any fraudulent or illegal activity
                </span>
              </li>
            </ul>
            <p className="text-slate-600" data-id="element-720">
              Where these apply, service may be suspended without refund.
            </p>
            <p className="text-sm text-slate-500 mt-6 italic" data-id="element-721">
              Note: Taskpoint provides repair and maintenance services only. No
              financial or replacement elements are included.
            </p>
          </div>
        </div>
      </section>
      <Footer data-id="element-722" />
    </div>;
};